import { createGlobalStyle } from 'styled-components'

import IBMPlexSansRegular from 'assets/fonts/IBMPlexSans-Regular.ttf'
import IBMPlexSansBold from 'assets/fonts/IBMPlexSans-Bold.ttf'
import IBMPlexSansMedium from 'assets/fonts/IBMPlexSans-Medium.ttf'
import botsBG from 'assets/icons/botsBG.png'

export enum colorsEnum {
  red = 'red',
  yellow = 'yellow',
  green = 'green',
  blue = 'blue',
  black = 'black',
  white33 = 'white33',
  white50 = 'white50',
  white66 = 'white66',
  white99 = 'white99',
  white = 'white',
  dark = 'dark',
  feeBlue = 'feeBlue',
  pink = 'pink',
  purple = 'purple',
  lightBlue = 'lightBlue',
  alabasterWhite = 'alabasterWhite',
  orange = 'orange',
}
class Theme {
  [key: string]: any
  red: string
  yellow: string
  green: string
  blue: string
  black: string
  dark: string
  white11: string
  white33: string
  white50: string
  white66: string
  white99: string
  white: string
  gray: string
  darkGray: string
  purple: string
  orange: string
  lightBlue: string
  pink: string
  freeze: string
  feeBlue: string
  alabasterWhite: string
  modalBackground: string
  obs_blue: string
  obs_background: string
  obs_block_background: string
  obs_border: string
  obs_font: string
  constructor() {
    this.red = '#F84960'
    this.yellow = '#F0B90B'
    this.green = '#02C076'
    this.blue = '#00FFE7'
    this.freeze = '#33D6FF'
    this.black = '#191b20'
    this.dark = '#111216'

    this.white11 = '#FFFFFF19'
    this.white33 = '#FFFFFF54'
    this.white50 = 'rgba(255, 255, 255, 0.5)'
    this.white66 = '#FFFFFFA9'
    this.white99 = '#FFFFFFE5'
    this.white = '#FFFFFF'
    this.alabasterWhite = '#EDEADE'

    this.darkGray = '#383e45'
    this.gray = '#4c535d'
    this.modalBackground = '#4C535DFF'

    this.purple = '#b700ff'
    this.orange = '#ff6200'
    this.lightBlue = '#4273ec'
    this.feeBlue = '#4597EC'
    this.pink = '#ff00fb'
    this.obs_background = '#111216'
    this.obs_block_background = '#14151A'
    this.obs_font = '#848CA0'
    this.obs_blue = '#26DFFA'
    this.obs_border = '#398EAB'
  }
  getColorByName(colorName: string | undefined): string {
    if (colorName) {
      return this?.[colorName] || this.alabasterWhite
    }
    return this.alabasterWhite
  }
  getColorWithOpacity(color: colorsEnum, opacity: number) {
    return this?.[color] + Math.floor((255 / 100) * opacity).toString(16)
  }
}
export const theme = new Theme()

export const GlobalStyle = createGlobalStyle`

  @font-face {
    font-family: IBMPlexSans;
    font-style: normal;
    font-weight: 400;
    src: url(${IBMPlexSansRegular});
  }

  @font-face {
    font-family: IBMPlexSans;
    font-style: normal;
    font-weight: normal;
    src: url(${IBMPlexSansRegular});
  }

  @font-face {
    font-family: IBMPlexSans;
    font-style: normal;
    font-weight: 500;
    src: url(${IBMPlexSansMedium});
  }

  @font-face {
    font-family: IBMPlexSans;
    font-style: normal;
    font-weight: 600;
    src: url(${IBMPlexSansBold});
  }

  html {
    
    background:${theme.black};
    overflow-x:hidden;
  }

  *,
  ::before,
  ::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    overflow-wrap: break-word;
    line-height: 1.25;

  }

  body {
    width: 100%;
    height: 100%;
    font-family: 'IBMPlexSans', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #fff;
    background-image: url(${botsBG});
    min-height: 100vh;
    ::-webkit-scrollbar {
      width: 0;
    }

    /* Track */

  }

  textarea {
    resize: none;
    font-family: 'Arial', sans-serif;
  }

  input {
    font-family: 'Arial', sans-serif;
  }

  button {
    font-family: 'Arial', sans-serif;
    outline: none;
    border: none;
    background: transparent;

    &:hover {
      cursor: pointer;
    }
  }

  *:focus {
    outline: none;
  }

  ul, li {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
  }

  [data-title]:hover:after {
    opacity: 1;
    transition: all 0.1s ease 1.5s;
    visibility: visible;
  }
  
  [data-title]:after {
    content: attr(data-title);
    color: white;
    visibility: hidden;
    position: absolute;
    border: 1px solid rgba(255, 255, 255, 0.33);
    border-radius: 5px;
    padding: 5px 10px;
    background: rgb(17, 18, 22);
    white-space: nowrap;
    transform: translate(-50%, 90%);
    z-index:2;
  }
  [data-title] {
    position: relative;
  }
`
